import request from '@/utils/request';
import * as types from '@/api/issue/types';
import { reqCatch, reqCatchV2, type catchRt } from '@/utils/catch';
import { ISSUE_PR_API_PREFIX, COMMENT } from '@/constant/index';
import { ApiType } from '@/utils/types';

export function createIssue(data: types.createIssueReqType): Promise<types.createIssueResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${data.project_id}/issues`,
    method: 'post',
    data
  });
}
export function deleteIssue(params: types.createIssueReqType): Promise<types.createIssueResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${params.project_id}/issues/${params.issue_iid}`,
    method: 'delete'
  });
}

export function updateIssue(data: types.updateIssueReqType): Promise<types.updateIssueResType> {
  const { project_id, issue_iid } = data;
  delete data.project_id;
  delete data.issue_iid;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${project_id}/issues/${issue_iid}`,
    method: 'put',
    data
  });
}

// 关闭或打开issue
export function updateIssueStat(data: types.updateIssueStatReqType): Promise<types.updateIssueStatResType> {
  const { project_id, issue_iid } = data;
  delete data.project_id;
  delete data.issue_iid;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${project_id}/issues/${issue_iid}/close`,
    method: 'put',
    data
  });
}

export function fetchIssue(params: types.fetchIssueReqType): Promise<types.fetchIssueResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${params.project_id}/issues/${params.issue_iid}`,
    method: 'get'
  });
}

// 项目issue列表
export function fetchIssueList(params: types.fetchIssueListReqType): Promise<types.fetchIssueListResType> {
  const { signal, ...otherParams } = params;
  return request(
    {
      url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${otherParams.project_id}/issues`,
      method: 'get',
      params: otherParams,
      signal
    },
    {
      customError: true
    }
  );
}

export function createIssueDiscussions(
  data: types.createIssueDiscussionsReqType
): Promise<types.createIssueDiscussionsResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${data.project_id}/issues/${data.issue_iid}/discussions`,
    method: 'post',
    data
  });
}

export function updateIssueDiscussions(
  data: types.updateIssueDiscussionsReqType
): Promise<types.updateIssueDiscussionsResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${data.project_id}/issues/${data.issue_iid}/notes/${data.note_id}`,
    method: 'put',
    data
  });
}

export function deleteIssueDiscussions(
  params: types.deleteIssueDiscussionsReqType
): Promise<types.deleteIssueDiscussionsResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${params.project_id}/issues/${params.issue_iid}/notes/${params.note_id}`,
    method: 'delete',
    params
  });
}

export function fetchIssueDiscussions(
  params: types.fetchIssueDiscussionsResType
): Promise<types.fetchIssueDiscussionsResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${params.project_id}/issues/${params.issue_iid}/discussions`,
    method: 'get',
    params
  });
}
// 获取issue单条评论
export function fetchIssueNote(
  params: types.fetchIssueDiscussionsResType
): Promise<types.fetchIssueDiscussionsResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${params.project_id}/issues/${params.issue_iid}/notes/${params.note_id}`,
    method: 'get'
  });
}

// 回复issue评论
export function freplyIssueDiscussions(data: types.createIssueReqType): Promise<types.createIssueResType> {
  return request(
    {
      url: `/api/v1/issue/api/v4/projects/${data.project_id}/issues/${data.issue_iid}/discussions/${data.discussion_id}/notes`,
      method: 'post',
      data
    },
    {
      customError: true
    }
  );
}

// issue参与者
export function issueParticipants(data: types.issueParticipantsResType): Promise<types.issueParticipantsReqType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${data.project_id}/issues/${data.issue_iid}/participants`,
    method: 'get'
  });
}

// issue 精选
export function pinIssue(params: types.pinIssueReqType): Promise<types.pinIssueResType> {
  return request({
    url: `/api/v2/projects/featured/${params.type}`,
    method: 'post',
    params
  });
}

export function deletePinIssue(params: types.deletePinIssueReqType): Promise<types.deletePinIssueResType> {
  return request({
    url: `/api/v2/projects/featured/${params.type}`,
    method: 'delete',
    params
  });
}

// 精选排序
export function sortPinIssue(data: any): Promise<types.pinIssueListResType> {
  const { type, group_id, body } = data;
  return request({
    url: `/api/v2/projects/featured/${type}/resort?group_id=${group_id}`,
    method: 'put',
    data: body
  });
}

export function pinIssueList(params: types.pinIssueListReqType): Promise<types.pinIssueListResType> {
  return request({
    url: `/api/v2/projects/featured/${params.project_id}/issues`,
    method: 'get'
  });
}

// 我的issue列表
export function myIssueList(params: types.fetchIssueListReqType): Promise<types.fetchIssueListResType> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issues`,
    method: 'get',
    params
  });
}

// 我的issue列表数量
export function myIssueListState(params: types.myIssueListStateReptype): Promise<types.myIssueListStateRestype> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issues/statistics`,
    method: 'get',
    params
  });
}
// 组织的issue列表
export function groupIssueList(params: types.fetchIssueListResType): Promise<types.fetchIssueListResType> {
  const { group_id } = params;
  delete params.group_id;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/groups/${group_id}/issues`,
    method: 'get',
    params
  });
}
// 获取issue关联的PR列表
export function getIssuePRList(params: types.fetchIssueListResType): Promise<types.fetchIssueListResType> {
  const { project_id, issue_iid } = params;
  delete params.project_id;
  delete params.issue_iid;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${project_id}/issues/${issue_iid}/linked_merge_requests`,
    method: 'get',
    params
  });
}
// issue关联PR
export function issueRelatePR(data: types.updateIssueReqType): Promise<types.fetchIssueListResType> {
  return reqCatch(
    () =>
      request(
        {
          url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${data.project_id}/issues/iid/${data.issue_iid}/merge_request/${data.merge_request_id}/linked_merge_requests`,
          method: 'post'
        },
        {
          customError: true
        }
      ),
    data
  );
}
// issue取消关联PR
export function issueDeletePR(params: types.updateIssueReqType): Promise<types.fetchIssueListResType> {
  return reqCatch(
    () =>
      request({
        url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${params.project_id}/issues/iid/${params.issue_iid}/linked_merge_requests/${params.merge_request_id}`,
        method: 'delete'
      }),
    params
  );
}

// 获取issue模板列表
export function fetchIssueTemplateList(project_id: string, language?: string): Promise<Record<string, any>> {
  return request({
    url: `/api/v2/projects/${project_id}/repository/template/issue`,
    method: 'get',
    params: {
      language
    }
  }).catch((e) => {
    return { data: [], error_code: e };
  });
}

// 验证labels是否在项目中存在
export function checkLabelsInProject(params: Record<string, any>): Promise<any> {
  return reqCatch(
    () =>
      request({
        url: `${ISSUE_PR_API_PREFIX}/api/v1/projects/${params.repoId}/labels/batch`,
        method: 'get',
        params: params
      }),
    params
  );
}

// 查询关联的分支列表
export function getRelatedBranchList(params: Record<string, any>): Promise<any> {
  const { project_id, issue_iid } = params;
  return reqCatch(
    () =>
      request({
        url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${project_id}/issues/${issue_iid}/related_branches`,
        method: 'get',
        params: {
          ...params,
          page: 1,
          // 最多100个
          per_page: 100
        }
      }),
    {
      ...params,
      page: 1,
      per_page: 100
    }
  );
}

// issue关联分支
export function setRelatedBranch(params: Record<string, any>): Promise<any> {
  const { project_id, issue_iid } = params;
  return reqCatch(() =>
    request({
      url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${project_id}/issues/${issue_iid}/references`,
      method: 'put',
      data: params
    })
  );
}

// issue / pr 附件上传
export function uploadAttachment(params: Record<string, any>): Promise<any> {
  const { project_id } = params;
  return reqCatch(() =>
    request({
      url: `/api/v2/projects/${project_id}/user_attachment/upload`,
      method: 'post',
      data: params
    })
  );
}

// 是否可以上传附件
export function canUploadAttachment(params: Record<string, any>): Promise<any> {
  const { project_id } = params;
  return reqCatch(() =>
    request({
      url: `/api/v2/projects/${project_id}/user_attachment/canUpload`,
      method: 'get',
      params: params
    })
  );
}

// 创建安全补丁fork项目
export function createIssueFork(data: Record<string, any>): Promise<any> {
  return request({
    url: `/api/v2/projects/${data.project_id}/issues/${data.issue_iid}/fork/${data.source_project_id}`,
    method: 'post'
  });
}

// 获取安全补丁fork项目项目列表
export function getIssueForkList(params: Record<string, any>): Promise<any> {
  return request({
    url: `/api/v2/projects/${params.project_id}/issues/${params.issue_iid}/forks`,
    method: 'get'
  });
}

// 获取安全issue处理人列表
export function getIssueForkAssignees(params: Record<string, any>): Promise<any> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${params.project_id}/issues/${params.issue_iid}/forks/${params.target_project_id}/assignees`,
    method: 'get'
  });
}

// 设置安全issue处理人列表
export function updateIssueForkAssignee(data: Record<string, any>): Promise<any> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/issue/${data.project_id}/issues/${data.issue_iid}/forks/${data.target_project_id}/assignees`,
    method: 'put',
    data: {
      assignee_ids: data.assignee_ids
    }
  });
}

// 安全issues白名单判断
export function checkIssueForkWhiteList(params: Record<string, any>): Promise<any> {
  const { type } = params;
  return request({
    url: `/api/v2/projects/wl/${type}`,
    method: 'post',
    data: params
  });
}

/** 获取issue类型列表 */
export function getIssueTypeList(params: { group_id: string }): catchRt<unknown> {
  return reqCatchV2(() =>
    request({
      url: `/api/v2/groups/${params.group_id}/issue-extend/issue_extend_type_list`,
      method: 'get'
    })
  );
}

// 获取issue 优先级列表 - 弃用
export function getIssuePriorityList(): catchRt<unknown> {
  return reqCatchV2(() =>
    request({
      url: `/api/v2/groups/issue-extend/issue_extend_priority_list`,
      method: 'get'
    })
  );
}

/** 根据类型获取issue状态列表 */
export function getIssueStatusList(params: {
  group_id: string;
  type: number | string;
  selectedId: number | string;
}): catchRt<unknown> {
  return reqCatchV2(() =>
    request({
      url: `/api/v2/groups/${params.group_id}/issue-extend/custom/${encodeURIComponent(params.type)}/${encodeURIComponent(params.selectedId)}`,
      method: 'get'
    })
  );
}
/** 获取当前issue状态 */
export function getCurrentIssueStatus(params: {
  project_id: number;
  issue_iid: number;
  custom: boolean;
}): catchRt<unknown> {
  return reqCatchV2(() =>
    request({
      url: `/issuepr/api/v1/issue/${params.project_id}/issue-extend/info/${params.issue_iid}`,
      method: 'get',
      params: {
        custom: params.custom
      }
    })
  );
}
/** 是否启用issue增强 */
export function getIssueEnable(params: { groupId: string }): catchRt<unknown> {
  return reqCatchV2(() =>
    request({
      url: `/api/v2/groups/${params.groupId}/issue-extend/issue_extend_open`,
      method: 'get'
    })
  );
}

/** 修改当前issue状态 */
export function changeCurrentIssueStatus(data: types.IssueStatusPut): Promise<any> {
  return request({
    url: `/issuepr/api/v1/issue/${data.project_id}/issue-extend/status-flow/${data.issue_iid}`,
    method: 'put',
    data: {
      status_before: data.statusBefore,
      status_current: data.statusCurrent
    }
  });
}

/** 修改当前issue优先级 */
export function updateCurrentIssuePriority(data: types.IssueStatusPut): Promise<any> {
  return request({
    url: `/issuepr/api/v1/issue/${data.project_id}/issue-extend/${data.issue_iid}/change_priority`,
    method: 'put',
    data: {
      priority: data.priority
    }
  });
}
/** 导出issue */
export function exportIssue(params: Record<string, any>): Promise<any> {
  return request(
    {
      url: `/${params.project_id}/issues/export.data`,
      method: 'get',
      apiType: ApiType.MAIN,
      headers: {
        'content-type': 'application/json;charset=utf-8'
      },
      responseType: 'blob',
      params: {
        ...params
      }
    },
    {
      customTimeout: 5 * 60 * 1000
    }
  );
}

/** 导出 issue - 创建导出任务 */
export function repoIssueExportTask(data: any): Promise<any> {
  return reqCatch(
    () =>
      request({
        url: `/issuepr/api/v1/projects/${data.project_id}/issues_export`,
        method: 'post',
        data: data
      }),
    data
  );
}

/** 导出 issue - 获取导出任务列表 */
export function getExportTaskList(params: Record<string, any>): Promise<any> {
  return reqCatch(
    () =>
      request({
        url: `/issuepr/api/v1/exports`,
        method: 'get',
        params: params
      }),
    params
  );
}

/** 导出 issue - 获取单个任务详情 */
export function getExportTaskDetail(params: { id: string }): Promise<any> {
  const { id } = params;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/exports/${id}`,
      method: 'get'
    })
  );
}

/** 导出 issue - 下载指定任务 */
export function downloadTargetFile(params: any): Promise<any> {
  const { id } = params;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/exports/${id}/obs/download`,
      method: 'get'
    })
  );
}

/** 导出 issue - 删除指定任务 */
export function deleteExportTask(params: any): Promise<any> {
  const { ids } = params;
  return reqCatch(() =>
    request({
      url: `/issuepr/api/v1/exports/clear`,
      method: 'delete',
      params: {
        ids
      }
    })
  );
}

// 修改 issue 类型
export function changeIssueType(data: types.deleteIssueReqType): Promise<any> {
  return request({
    url: `/issuepr/api/v1/issue/${data.project_id}/issue-extend/change_type/${data.issue_iid}`,
    method: 'put',
    data: {
      new_type_name: data.new_type_name
    }
  });
}

/** 获取 issue 创建者/负责人 列表，只用于 org issue 列表筛选 */
export function getUsersInOrgIssueList(params: {
  groupId: string;
  page?: number;
  per_page?: number;
  query?: string;
  current_user_at_top?: boolean;
  user_type: 'assignee' | 'author';
}): Promise<any> {
  const { groupId, ...param } = params;
  return request(
    {
      url: `${ISSUE_PR_API_PREFIX}/api/v1/groups/${groupId}/issues/users`,
      method: 'get',
      params: Object.assign({ page: 1, per_page: 10 }, param)
    },
    {
      customError: true
    }
  );
}

// ------------ issue/pr 评论历史版本功能 ----------------------//

interface PraiseList {
  type: string | number; // 类型
  resource_id_List: Array<string>;
}
// 根据资源id批量获取-是否有修改历史
export function getResourceVersionExist(params: PraiseList): Promise<any> {
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/audit_log/resource/exist?type=${params.type}&resource_id_list=${params.resource_id_List}`,
    method: 'get'
  });
}

// 查询指定资源id的修改历史列表 - issue/pr 描述单独调用
export function getResourceVersionList(params: {
  project_id: string;
  type: string | number;
  resource_id: string;
}): Promise<any> {
  const { project_id, type, resource_id } = params;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/audit_log/project/${project_id}/type/${type}/resource/${resource_id}/content`,
    method: 'get'
  });
}

// 批量获取版本详情
export function getResourceVersionsDetail(params: {
  project_id: string;
  id_list: string;
  type: string | number;
}): Promise<any> {
  const { project_id, id_list, type } = params;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/audit_log/project/${project_id}/type/${type}/resource/list`,
    method: 'get',
    params: {
      id_list
    }
  });
}

// 删除单条历史版本记录
export function deleteVersion(data: { project_id: string; id: string; type: string | number }): Promise<any> {
  const { project_id, id, type } = data;
  return request({
    url: `${ISSUE_PR_API_PREFIX}/api/v1/audit_log/project/${project_id}/type/${type}/id/${id}/content`,
    method: 'delete'
  });
}

// 批量获取多资源id的修改历史 - 业务封装了下
export const getResourceVersionExistMulti = async (allDiscussionNoteIds: any[], type = COMMENT.MR) => {
  const params = { type, resource_id_List: allDiscussionNoteIds };
  const data = (await getResourceVersionExist(params)) || {};
  if (data?.status === 200) {
    return data.data || [];
  }
  return [];
};
